import { GlobalContext } from "Global/Base/GlobalContext";
import { OWManager } from "../OWManager";
import { Enum, EnumProxyHandler } from "./Enums";

export interface IFlags {
    fNone: Enum;
    fRed: Enum;
    fGreen: Enum;
    fBlue: Enum;
    fBlack: Enum;
    fGray: Enum;
    fSilver: Enum;
    fYellow: Enum;
    fBrown: Enum;
    fLime: Enum;
    fNavy: Enum;
    fAqua: Enum;
    fFuchsia: Enum;
    fPink: Enum;
    fDeepPurple: Enum;
    fLightBlue: Enum;
    fTeal: Enum;
    fLightGreen: Enum;
    fAmber: Enum;
    fOrange: Enum;
    fDeepOrange: Enum;
    [key: string]: Enum;
}

export class Flags {
    private static _flags: IFlags | null = null;

    /**
     * Reference na promise posledního načítání enumu vlajek nebo null, pokud se ještě nenačítalo.
     * @private
     */
    private static _loadingPromise: Promise<IFlags | null> = null;

    public static get(value: string): Enum | null {
        if (!this.flags)
            return null;

        return this.flags[value];
    }

    /**
     * Získá promise pro poslední načítání enumu vlajek. Pokud ještě nebyl žádný požadavek na načtení, zavolá {@link Flags.loadFlags} a vrátí
     * jeho promise.
     */
    public static get loadingPromise(): Promise<IFlags | null> {
        if (Flags._loadingPromise) {
            return Flags._loadingPromise;
        } else {
            return Flags.loadFlags();
        }
    }

    public static get flags(): IFlags | null {
        if (self !== top) {
            return GlobalContext.getType<typeof Flags>(Flags).flags;
        } else
            return this._flags;
    }

    public static set flags(value: IFlags | null) {
        this._flags = value;
    }

    public static loadFlags(): Promise<IFlags | null> {
        Flags._loadingPromise = new Promise<IFlags>(resolve => {
            if (typeof document !== "undefined") {
                if (!Flags.flags && self === top) {
                    OWManager.getEnum("Flags")
                        .then((flagsEnum) => {
                            Flags.flags = new Proxy(flagsEnum, EnumProxyHandler) as any as IFlags;
                            resolve(Flags.flags);
                        });
                } else {
                    resolve(null);
                }
            } else {
                resolve(null);
            }
        });
        return Flags._loadingPromise;
    }
}

GlobalContext.registerType(Flags);
